

<div class="input">
    <p class="label">{{label}} <span *ngIf="formControl?.validator && formControl.validator(formControl) && formControl.validator(formControl).required">*</span></p>
	<ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
	<ng-container *ngIf="formControl; else noControl">
		<input [id]="'address-input-' + inputId" [ngClass]="{'_has-results': searchResults.length > 0}" (input)="autocomplete($any($event).target.value)" type="text" [name]="controlName" [formControl]="formControl" autocomplete="no-auto" [readonly]="readonly">
	</ng-container>
	<ng-template #noControl>
		<input [id]="'address-input-' + inputId" [ngClass]="{'_has-results': searchResults.length > 0}" (input)="autocomplete($any($event).target.value)" type="text" autocomplete="no-auto" [readonly]="readonly">
	</ng-template>
	<div class="_status">
		<ng-container *ngIf="loading; else result">
			<ion-spinner name="dots"></ion-spinner>
		</ng-container>
		<ng-template #result>
			<ion-icon *ngIf="error" class="_invalid" src="./assets/icons/invalid-code.svg"></ion-icon>
		</ng-template>
	</div>
    <form-validation-error *ngIf="formControl" [control]="formControl"></form-validation-error>
    <div class="_search-results" *ngIf="searchResults.length > 0">
        <p class="_search-result" *ngFor="let result of searchResults" (click)="selectAddress(result)">{{result.description}}</p>
    </div>
</div>